var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 2.68629 9.31371 0 6 0V6L1.5 9.96874C2.59942 11.2144 4.20796 12 6 12C7.79204 12 9.40058 11.2144 10.5 9.96874C11.4335 8.91104 12 7.52167 12 6Z",
    fill: "#149C08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 7.52167 0.566455 8.91104 1.5 9.96874L6 6V0Z",
    fill: "#149C08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 7.52167 0.566455 8.91104 1.5 9.96874L6 6V0Z",
    fill: "#FF9C08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9.96874L6 6L1.5 9.96874C2.59942 11.2144 4.20796 12 6 12C7.79204 12 9.40058 11.2144 10.5 9.96874Z",
    fill: "#FF9C08"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68629 0 0 2.68629 0 6C0 7.52167 0.566455 8.91104 1.5 9.96874L6 6V0Z",
    fill: "#FF3636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.5c718ff5.svg";
export { ForwardRef as ReactComponent };